<template>
<div class="justify-center text-center py-7 mx-auto white rounded-lg" style="width: 90vw">
  <v-layout column>
    <v-flex xs6 offset-xs3 mx-auto>
      <div class="white elevation-0">
        <v-toolbar flat dense color=primary>
          <v-toolbar-title>Administration</v-toolbar-title>
        </v-toolbar>
        <div class="px-4 py-2">
          <form v-on:submit.prevent="login">
            <v-text-field
              label="Username"
              v-model="username"
            ></v-text-field>
            <v-text-field
              label="Password"
              type="password"
              v-model="password"
            ></v-text-field>
            <v-alert dense outlined v-if="errorMsg" type="error">
              {{errorMsg}}
            </v-alert>
            <v-btn type="submit" x-large color="accent" dark>Login</v-btn>
          </form>
        </div>
      </div>
    </v-flex>
  </v-layout>
</div>
</template>

<script>

import AuthenticationService from '@/services/AuthenticationService'
export default {
  name: 'Register',
  data () {
    return {
      username: '',
      password: '',
      errorMsg: null
    }
  },
  watch: {
    // email (value) {
    //   console.log('email has changed value to ' + value)
    // }
  },
  mounted () {
    // Called when the view is pulled into, well... view

  },
  methods: {
    async login () {
      try {
        const response = await AuthenticationService.login({
          username: this.username,
          password: this.password
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({ name: 'Medlemsliste' })
      } catch (error) {
        this.errorMsg = error.response.data.error
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error {
  color: red;
}
</style>
